import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import HomePage from '@/components/HomePage';
import ErrorPage from '@/components/ErrorPage';
import EmbedVideo from '@/components/EmbedVideo';
import PlaylistVideo from '@/components/PlaylistVideo';
import EmbedPodcast from '@/components/EmbedPodcast';
import VideoCir from '@/components/VideoCir';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/permalien/:videoId(\\d+)/:user',
      name: 'permalien',
      component: HomePage,
    },
    {
      path: '/video/cir/:videoId(\\d+)/:user',
      name: 'videocir',
      component: VideoCir,
    },
    {
      path: '/theme/:themeId(\\d+)/:user',
      name: 'theme',
      component: HomePage,
    },
    {
      path: '/playlist/:playlistId/:user',
      name: 'playlist',
      component: PlaylistVideo,
    },
    {
      path: '/:category(all|trends|popular)/:user',
      name: 'home',
      component: HomePage,
      props: route => ({
        query: route.query.q,
      }),
    },
    {
      path: '/embed/playlist/:playlistId/:user',
      name: 'embedPlaylist',
      component: EmbedVideo,
    },
    {
      path: '/embed/:videoId/:user',
      name: 'video',
      component: EmbedVideo,
    },
    {
      path: '/podcast/:token/:user',
      name: 'podcast',
      component: EmbedPodcast,
    },
    {
      path: '/podcast/:token/:user',
      name: 'podcast',
      component: EmbedPodcast,
    },
    {
      path: '/error/404',
      name: 'error',
      component: ErrorPage,
    },
    {
      path: '/:user',
      name: 'index',
      redirect: '/trends/:user',
    },
    {
      path: '*',
      redirect: '/error/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!(to.params.user || to.name === 'error')) {
    if (from.params.user) {
      const { name, params } = to;
      next({ name, params: { ...params, user: from.params.user } });
    }
    next('/404');
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/user.js